import Lang from 'lang.js';
import messages from '@lang/json/home-ezekia.json';

window.Lang = new Lang({
    messages: messages,
    locale: window.nal.locale,
    fallback: 'en',
});